import admin from './admin'
import artifacts from './artifacts'
import auth from './auth'
import billing from './billing'
import columns from './columns'
import common from './common'
import courses from './courses'
import dashboard from './dashboard'
import dialogs from './dialogs'
import emails from './emails'
import landing from './landing'
import learningFacets from './learningFacets'
import marketing from './marketing'
import media from './media'
import navigation from './navigation'
import personalTrail from './personalTrail'
import platform from './platform'
import resources from './resources'
import roadmaps from './roadmaps'

export default {
	common,
	admin,
	artifacts,
	billing,
	columns,
	courses,
	dashboard,
	dialogs,
	landing,
	learningFacets,
	marketing,
	media,
	navigation,
	personalTrail,
	platform,
	auth,
	emails,
	resources,
	roadmaps,
}
